<script setup lang="ts">
import { computed, watch } from 'vue';
import { AFieldInputText } from '@FormModule';

const emit = defineEmits<{
  enter: [];
}>();

const props = withDefaults(
  defineProps<{
    class?: string;
    confirmWord: string;
    inputClass?: string;
    messageKey?: string;
    placeholder?: string;
  }>(),
  {
    messageKey: 'cart.dialogs.emptyCart.confirmation',
    placeholder: 'cart.doNotAdopt.placeholder',
  }
);

const model = defineModel<string>({ default: '' });

const isValid = computed(
  () => !props.confirmWord || model.value.trim().toLowerCase() === props.confirmWord.trim().toLowerCase()
);

watch(
  () => props.confirmWord,
  () => (model.value = '')
);

defineExpose({
  get isValid() {
    return isValid.value;
  },
});

function onKeydownEnter(e: Event) {
  e.preventDefault();
  emit('enter');
}
</script>

<template>
  <div :class="['flex flex-col items-center gap-2', props.class]">
    <i18n-t
      class="text-center"
      tag="span"
      :keypath="messageKey"
    >
      <template #word>
        <b>"{{ confirmWord }}"</b>
      </template>
    </i18n-t>

    <AFieldInputText
      v-model="model"
      :class="inputClass || 'w-full max-w-[200px]'"
      :placeholder="$t(placeholder)"
      @keydown.enter="onKeydownEnter"
    />
  </div>
</template>
